import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeLessonDataSkeleton } from './TypeLessonData'

export interface TypeLessonPreviewFields {
  title: EntryFieldTypes.Symbol
  cover: EntryFieldTypes.AssetLink
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  lessonData: EntryFieldTypes.EntryLink<TypeLessonDataSkeleton>
  accent?: EntryFieldTypes.Symbol<'au' | 'ca' | 'uk' | 'us'>
}

export type TypeLessonPreviewSkeleton = EntrySkeletonType<TypeLessonPreviewFields, 'lessonPreview'>
export type TypeLessonPreview<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeLessonPreviewSkeleton,
  Modifiers,
  Locales
>

export function isTypeLessonPreview<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeLessonPreview<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'lessonPreview'
}

export type TypeLessonPreviewWithoutLinkResolutionResponse = TypeLessonPreview<'WITHOUT_LINK_RESOLUTION'>
export type TypeLessonPreviewWithoutUnresolvableLinksResponse = TypeLessonPreview<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeLessonPreviewWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeLessonPreview<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeLessonPreviewWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeLessonPreview<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeLessonPreviewWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeLessonPreview<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
